export default "__VITE_ASSET__74151ccc__"